var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
      ref: "form",
      attrs: {
        model: _vm.form,
        rules: _vm.rules,
        "element-loading-spinner": "el-icon-loading",
        "label-width": "250",
      },
    },
    [
      _c("div", [
        _c("p", [_vm._v("Structure of the import file:")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [_vm._v("First name")]),
          _vm._v(" "),
          _c("li", [_vm._v("Last name")]),
          _vm._v(" "),
          _c("li", [_vm._v("Filemaker ID")]),
          _vm._v(" "),
          _c("li", [_vm._v("Email address")]),
          _vm._v(" "),
          _c("li", [_vm._v("Phone number")]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Import File:", prop: "file" } },
        [
          _vm.isFileSelected
            ? _c("div", [
                _c("em", [_vm._v(_vm._s(this.fileInfo))]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "btn btn-link btn-link-red px-1",
                    on: { click: _vm.clearFile },
                  },
                  [_c("i", { staticClass: "fas fa-times-circle" })]
                ),
              ])
            : _c("file-input", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ clickHandler }) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "btn btn-link btn-link-purple px-0",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return clickHandler.apply(null, arguments)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fas fa-folder-open" })]
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.form.file,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "file", $$v)
                  },
                  expression: "form.file",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "replace_filemaker_id" } },
        [
          _c(
            "el-checkbox",
            {
              attrs: { "true-label": 1, "false-label": 0 },
              model: {
                value: _vm.form.replace_filemaker_id,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "replace_filemaker_id", $$v)
                },
                expression: "form.replace_filemaker_id",
              },
            },
            [_vm._v("Replace Filemaker ID")]
          ),
          _vm._v(" "),
          _c(
            "el-tooltip",
            {
              attrs: {
                effect: "light",
                content:
                  "If a contact already has a different Filemaker ID, replace it with the filled one from the file. Otherwise the existing ID is kept.",
                placement: "top-start",
              },
            },
            [_c("i", { staticClass: "far fa-question-circle ml-1" })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form-item", [
        _c(
          "button",
          {
            staticClass: "btn btn-purple",
            attrs: { disabled: !_vm.isFileSelected },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.store.apply(null, arguments)
              },
            },
          },
          [_vm._v("Process")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }